import { useEffect } from "react";

const TARGETS = "button:not(:disabled), a.gold-hover-button, .service-spotlight, .service-card-panel, .raised-surface, .gold-check-row, .gold-hover-label, .conversation-label";

export const useTouchFeedback = (root) => {
  useEffect(() => {
    const container = root.current;
    let active = [];
    let origin = null;
    let timer;
    const clear = () => {
      window.clearTimeout(timer);
      active.forEach((element) => element.removeAttribute("data-touch-active"));
      active = [];
      origin = null;
    };
    const down = (event) => {
      if (event.pointerType !== "touch") return;
      clear();
      origin = { x: event.clientX, y: event.clientY };
      let element = event.target;
      while (element && element !== container) {
        if (element.matches?.(TARGETS) && element.getAttribute("aria-disabled") !== "true") {
          element.setAttribute("data-touch-active", "true");
          active.push(element);
        }
        element = element.parentElement;
      }
    };
    const move = (event) => {
      if (origin && Math.hypot(event.clientX - origin.x, event.clientY - origin.y) > 10) clear();
    };
    const up = () => { origin = null; timer = window.setTimeout(clear, 280); };
    container.addEventListener("pointerdown", down, { passive: true });
    window.addEventListener("pointermove", move, { passive: true });
    window.addEventListener("pointerup", up, { passive: true });
    window.addEventListener("pointercancel", clear, { passive: true });
    window.addEventListener("scroll", clear, { passive: true, capture: true });
    return () => {
      clear();
      container.removeEventListener("pointerdown", down);
      window.removeEventListener("pointermove", move);
      window.removeEventListener("pointerup", up);
      window.removeEventListener("pointercancel", clear);
      window.removeEventListener("scroll", clear, true);
    };
  }, [root]);
};
